export interface UnderlyingBond {
  id: string;
  isin: string;
  name: string;
  symbol: string;
  coupon_rate: string;
  maturity_date: string;
}

export interface TokenizedAssetPool {
  pool_id: string;
  name: string;
  token_currency_code: string;
  status: string;
  is_active: boolean;
  fireblocks_asset_id: string;
  activated_at: string;
  created_at: string;
  status_updated_at: string;
  status_metadata: string;
  underlying_bond_code: string | null;
  underlying_bond?: UnderlyingBond;
  xrpl_issuer_address: string;
  xrpl_issuer_vault_id: string;
  xrpl_operation_address: string;
  xrpl_operation_vault_id: string;
  resource_uri: string;
}

export interface TokenizedAssetPoolResponse {
  meta: {
    limit: number;
    next: string | null;
    offset: number;
    previous: string | null;
    total_count: number;
  };
  objects: TokenizedAssetPool[];
}

export enum TokenizedAssetPoolQueryKeys {
  TokenizedAssetPools = 'tokenized_asset_pools',
}
